import PropTypes from "prop-types";
import React from "react";

const Title = ({ children, style, className }) => {
  return (
    <h3
      className={`color-grayColor t-18 poppins weight-500 ${className}`}
      style={style && style}
    >
      {children}
    </h3>
  );
};

export default Title;
Title.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
};
